import { PostgrestError } from "@supabase/supabase-js";
import { Notification } from "providers/NotifierProvider";
import { supabase } from "supabase/client";
import { Database } from "supabase/types";
import logSentryError from "utils/logSentryError";

type DbAppStatus = Database["public"]["Tables"]["app_status"];
export interface AppStatusRow extends Omit<DbAppStatus["Row"], "info"> {
  info: AppStatus;
}
export interface AppStatusInsert extends Omit<DbAppStatus["Insert"], "info"> {
  info?: AppStatus;
}
export interface AppStatusUpdate extends Omit<DbAppStatus["Update"], "info"> {
  info?: AppStatus;
}

export interface AppStatus {
  changelog: {
    changes: string[];
    version: string;
  };
  announcement: {
    active: boolean;
    text: string;
    type: "info" | "warning";
    date: number; // unix timestamp
  };
  maintenance: {
    active: boolean;
    text: string;
  };
  showFeedback: boolean;
  update: {
    changes: [];
    webAppText: string;
    mobileAppText: string;
    version: string;
  };
}

class AppStatusApi {
  showNotification?: (notification: Notification) => void;

  constructor(showNotification?: (notification: Notification) => void) {
    this.showNotification = showNotification;
  }

  /**
   * Get app status
   *
   * @returns
   */
  async getAppStatus(): Promise<{
    appStatus: AppStatus | null;
    error: PostgrestError | null;
  }> {
    const { data, error } = await supabase.from("app_status").select("info").single();

    if (error) {
      if (this.showNotification) {
        this.showNotification({
          message: "Unable to get app status.",
          severity: "error",
        });
      }

      logSentryError(error, "APP_STATUS_API: getAppStatus");
      return { appStatus: null, error };
    }

    return {
      appStatus: (data?.info as unknown as AppStatus) ?? null,
      error: null,
    };
  }
}

export default AppStatusApi;
